import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {buildQueryRegex} from '../../query/elastic.queries';

export class BandsParser implements ElasticParser {
  parseValue(bandsString: string, elasticSearchProperty: ElasticSearchProperty): any {
    const {property} = elasticSearchProperty;

    const bandsRegexQueries = bandsString?.split(',')
      .map(band => band.trim())
      .filter(band => !!band)
      .map(band => buildQueryRegex(property, `.*${band}.*`));

    if (bandsRegexQueries?.length > 0) {
      return {bool: {should: bandsRegexQueries}};
    } else {
      return undefined;
    }
  }
}
